export default __webpack_public_path__ + "static/media/icon_private_m.9dcfeb65.svg";